import React from 'react';
import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';
import { Backdrop, Box, CircularProgress, LinearProgress } from '@mui/material';
import { getReportDivisions } from '../components/glossary/glossary.api';
import { getReport } from '../components/report/report.api';
import keys from '../common/react-query/data-keys';
import { handleError } from '../common/utils/util.errors';
import { ReportWrapper } from '../components/report/ReportWrapper';

const ReportPage: React.FC = () => {
  const { state } = useLocation();
  const { reportId: paramReportId } = useParams();
  const reportId = paramReportId || state?.reportId;
  const {
    data: report,
    isLoading: isLoadingReport,
    isRefetching: isRefetchingReport,
    isError: isErrorInReport,
    error: errorInReport,
  } = useQuery([keys.caReport, reportId], () => getReport(reportId), {
    enabled: Boolean(reportId),
  });

  const {
    data: divisions,
    isLoading: isLoadingDivisions,
    isError: isErrorDivisions,
    error: errorDivisions,
  } = useQuery([keys.divisions, reportId], () => getReportDivisions(reportId), {
    enabled: !!reportId,
    structuralSharing: false,
  });

  if (isLoadingReport || isLoadingDivisions) return <LinearProgress />;
  if (isErrorInReport || isErrorDivisions) {
    const error = errorInReport || errorDivisions;
    handleError(error);
    return null;
  }

  return (
    <Box>
      <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={isRefetchingReport || isLoadingReport}>
        <CircularProgress color='inherit' />
      </Backdrop>
      {report && divisions ? <ReportWrapper initialReport={report} divisions={divisions} /> : null}
    </Box>
  );
};

export default ReportPage;
